export default __webpack_public_path__ + "static/media/Documentation.59ba9324.md";